export default __webpack_public_path__ + "static/media/addIcon.05d4935e.svg";